<template>
  <div>
    <h3 class="text-center p-10 text-primary-500 font-bold">
      Peer Link Pro
    </h3>
    <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
      <validation-provider v-slot="{ errors }" vid="generic" slim>
        <d-message v-if="errors.length > 0" type="error" class="w-full mb-3">
          {{ errors[0] }}
        </d-message>
      </validation-provider>
      <p class="text-center">You are logging into the Mentoring Network for the Kansas Center for CTE</p>
      <form ref="form" method="post" action="/account/login" @submit.prevent="passes(submitForm)">
        <input type="hidden" name="ReturnUrl" :value="returnUrl">
        <d-field label="Email" vid="email" rules="required">
          <d-input v-model="form.email" name="email" required />
        </d-field>
        <d-field label="Password" vid="password" rules="required">
          <d-input v-model="form.password" name="password" required type="password" />
        </d-field>
        <div class=" pt-5  text-right">
          <div class="md:w-1/3 w-full float-right">
            <d-btn type="submit" :loading="submitting" block>
              Log In
            </d-btn>
          </div>
          <br>
          <div class="w-full float-right">
            <a class="my-5 block text-primary-600" href="/forgotpassword/index">Forgot your password?</a>
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import localforage from 'localforage';

  export default {
    parent: true,

    props: {
      returnUrl: String,

      pageErrors: {
        type: Array,
        default: () => [],
      },
    },

    data: (vm) => ({
      submitting: false,
      form: {
        email: '',
        password: '',
        rememberMe: false,
        returnUrl: vm.returnUrl,
      },
    }),

    mounted() {
      if (this.pageErrors.length > 0) {
        localforage.setItem('loginEmail', null);
        this.processOnRenderErrors(this.pageErrors, this.form);
      }
      localforage.getItem('loginEmail')
        .then((value) => {
          this.form.email = value;
        });
    },

    methods: {
      submitForm() {
        this.submitting = true;
        localforage.setItem('loginEmail', this.form.email);
        this.$refs.form.submit();
      },
    },
  };
</script>